/**
 * Kebab-case a given string
 *
 * @param {string} str String to convert
 * @returns {string} kebab-cased string
 */
export function toKebabCase(str) {
  return str
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/[^a-z0-9]+/gi, "-")
    .replace(/^[^a-z0-9]+/i, "")
    .replace(/[^a-z0-9]+$/i, "")
    .toLowerCase();
}

/**
 * Sentence case a given string
 *
 * @param {string} str
 * @returns {string}
 */
export function toSentenceCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/**
 * Escape HTML tags in a string template for use in i18n
 * formatting.
 * Accepts either a string or an array of strings.
 *
 * e.g.
 *
 * "<p><a href=#>some link</a> to a place</p>" =>
 *   "'<p><a href=#>some link</a>' to a place'</p>'"
 *
 * @param {string|Array<string>} template
 * @returns {string}
 */
export function escapeTags(template) {
  if (Array.isArray(template)) {
    // eslint-disable-next-line no-param-reassign
    template = template.join("");
  }

  return template.replace(/</g, "'<").replace(/>/g, ">'").replace(/''/g, "");
}
